<template>
  <span>
    <li
      klickbox-edit-item="progress-bullet-active"
      klickbox-edit-item-dad="progress"
      :klickbox-edit-label="$t('edit.canvas.active_item')"
      :style="getLiStyle()"
      class="active">
      <span
        class="kbx-subtitle"
        :style="getSpanStyle()"
        v-html="getSVG()">
      </span>
      <span :style="getNumberStyle()" class="kbx-number">2</span>
    </li>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    getStyle() {
      return this.stepStyle('progress-bullet-active');
    },
    getLiStyle() {
      const kind = this.boxConfig.progressbar.kind;
      const styles = this.getStyle();

      if (kind === 'bullet') {
        return {};
      }

      if (kind === 'svg') {
        return { color: styles.color };
      }

      return styles;
    },
    getSpanStyle() {
      const kind = this.boxConfig.progressbar.kind;
      const styles = this.getStyle();

      if (kind === 'standard' || kind === 'mask') {
        return {};
      }

      return styles;
    },
    getNumberStyle() {
      const kind = this.boxConfig.progressbar.kind;
      const styles = this.getStyle();

      if (kind === 'svg') {
        return { color: styles.color };
      }

      return {};
    },
    getSVG() {
      const kind = this.boxConfig.progressbar.kind;

      if (kind !== 'svg') {
        return '';
      }

      const span = document.createElement('span');
      const progressBarSVG = this.boxConfig.progressbar.svg.bullet;
      const styles = this.getStyle();

      if (!progressBarSVG) {
        return span;
      }

      span.innerHTML = progressBarSVG;
      const svg = span.firstChild;

      if (!styles) {
        return svg.outerHTML;
      }

      svg.style.fill = styles.backgroundColor;
      svg.style.stroke = styles.borderColor;

      return svg.outerHTML;
    },
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Active.vue?92524758
 **/